import React, { useState, useEffect, useCallback } from "react";
import moment from "moment";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import SmartPageHeader from "../../../components/smart/PageHeader/PageHeader";
import DailyEntries from "../../../components/smart/DailyEntries/DailyEntries";
import { DailyListKeys } from "../../../components/smart/DailyEntries/Constants";
import {
  dailyEntries,
  mapDispatchToProps,
  mapStateToProps,
} from "../../../components/smart/DailyEntries/DailyEntries.store";
import { useTranslation } from "react-i18next";
import DietDiaryMenuItems from "../../../components/smart/DietDiaryMenuItems/DietDiaryMenuItems";

const ParticipantLanding = (props) => {
  const {
    yesterdayEntries,
    todayEntries,
    fetchEntries,
    route,
    studies,
    dailyTargets,
    resetState,
    canAddMeal,
    participantDateOfEnrollment,
  } = props;

  const { t } = useTranslation();

  const refreshData = useCallback(() => {
    fetchEntries({ date: moment(), key: DailyListKeys.todayListName });
    fetchEntries({
      date: moment().subtract(1, "days"),
      key: DailyListKeys.yesterdayListName,
    });
  }, [fetchEntries]);

  useEffect(() => {
    if (!todayEntries) {
      fetchEntries({ date: moment(), key: DailyListKeys.todayListName });
    }
  }, [todayEntries, fetchEntries]);

  useEffect(() => {
    if (!yesterdayEntries) {
      fetchEntries({
        date: moment().subtract(1, "days"),
        key: DailyListKeys.yesterdayListName,
      });
    }
  }, [yesterdayEntries, fetchEntries]);

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  const today = moment();

  const dailyEntries = [
    {
      title: t("appText.today"),
      date: today,
      dailyItemKey: DailyListKeys.todayListName,
      goalsChartTitle: t("appText.dietDiary.macronutrientsPanel.today.title"),
      listTitle: "",
      dailyEntry: todayEntries,
      dailyGoals: dailyTargets,
      closeDietDiaryAction: () => refreshData(),
      participantDateOfEnrollment: participantDateOfEnrollment,
      refetchData: (date) =>
        fetchEntries({ date: date, key: DailyListKeys.todayListName }),
    },
    {
      title: t("appText.yesterday"),
      date: today.clone().subtract(1, "days"),
      dailyItemKey: DailyListKeys.yesterdayListName,
      goalsChartTitle: t(
        "appText.dietDiary.macronutrientsPanel.yesterday.title"
      ),
      listTitle: t("appText.dietDiary.entriesPanel.yesterday.title"),
      dailyEntry: yesterdayEntries,
      dailyGoals: dailyTargets,
      closeDietDiaryAction: () => refreshData(),
      participantDateOfEnrollment: participantDateOfEnrollment,
      refetchData: (date) =>
        fetchEntries({
          date: date,
          key: DailyListKeys.yesterdayListName,
        }),
    },
  ];

  return (
    <>
      <SmartPageHeader
        title={studies && studies[0]?.code}
        studyId={route.study}
        subtitle=""
        roleName={t("appText.participant")}
        shouldFetchParticipant={true}
      />

      {canAddMeal && <DietDiaryMenuItems refreshData={refreshData} />}

      {dailyEntries &&
        dailyEntries.map((entry) => (
          <DailyEntries
            key={`daily-entry-${entry.dailyItemKey}`}
            title={entry.title}
            date={entry.date}
            dailyItemKey={entry.dailyItemKey}
            goalsChartTitle={entry.goalsChartTitle}
            listTitle={entry.listTitle}
            dailyEntry={entry.dailyEntry}
            dailyGoals={entry.dailyGoals}
            closeDietDiaryAction={entry.closeDietDiaryAction}
            participantDateOfEnrollment={participantDateOfEnrollment}
            refetchData={entry.refetchData}
          />
        ))}
    </>
  );
};

const combineMapStateToProps = (state) => ({
  ...mapStateToProps(state),
  participantDateOfEnrollment:
    state.smartPageHeaderReducer?.participantDateOfEnrollment,
});

export default dynamic(
  "ParticipantLanding",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => ({
      loginReducer: { ...state.loginReducer },
    }),
  }),
  attachReducer(dailyEntries)
)(connect(combineMapStateToProps, mapDispatchToProps)(ParticipantLanding));
